import { styled as e } from "styled-components";
//#region src/components/QuickActions/styled/QuickActions.styled.ts
var t = e.div`
    display: grid;
    grid-template-columns: repeat(${({ $columns: e }) => e}, 1fr);
    gap: ${({ theme: e }) => e.spacing(1.5)};

    @media (max-width: 640px) {
        grid-template-columns: repeat(2, 1fr);
    }
`;
//#endregion
export { t as ActionsGrid };
